import React from 'react';
import {useSelector} from 'react-redux';

import DeviceTypes from '../../../consts/devices/devicesTypes.ts';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {makeSelectBuildingProfile} from '../../../state/selectors/buildings';
import {IconElectricity, IconHeatCostAllocator, IconSnowFlake, IconUtilsHeating, IconWaterDrop} from '../../Icons';

const indicatorIcons = [
    {type: DeviceTypes.Heat, icon: <IconUtilsHeating />},
    {type: DeviceTypes.ColdWater, icon: <IconWaterDrop />},
    {type: DeviceTypes.HotWater, icon: <IconWaterDrop fill='#F25555' />},
    {type: DeviceTypes.Electricity, icon: <IconElectricity fill='#0187F9' />},
    {type: DeviceTypes.Cooling, icon: <IconSnowFlake />},
    {type: DeviceTypes.HeatCostAllocator, icon: <IconHeatCostAllocator />},
];

const ObjectUtilitiesDrawerSection = ({mobile = false}) => {
    const buildingProfile = useSelector(makeSelectBuildingProfile());

    const {devicesCounts = {}} = buildingProfile || {};

    if (mobile) {
        const localizedStrings = getLocalizedStrings();
        const labels = {
            [DeviceTypes.Heat]: localizationKeys.BUILDING_PROFILE_PAGE_ROOMS_TABLE_TAB_SELECT_HEAT,
            [DeviceTypes.ColdWater]: localizationKeys.BUILDING_PROFILE_PAGE_ROOMS_TABLE_TAB_SELECT_COLD_WATER,
            [DeviceTypes.HotWater]: localizationKeys.BUILDING_PROFILE_PAGE_ROOMS_TABLE_TAB_SELECT_HOT_WATER,
            [DeviceTypes.Electricity]: localizationKeys.BUILDING_PROFILE_PAGE_ROOMS_TABLE_TAB_SELECT_ELECTRICITY,
            [DeviceTypes.Cooling]: localizationKeys.MAP_BUILDING_COOLING,
            [DeviceTypes.HeatCostAllocator]: localizationKeys.MAP_BUILDING_ALLOCATORS,
        };

        return (
            <ul className='map-building-mobile-utilities' role='list'>
                {indicatorIcons.map(({type, icon}) => (
                    <li key={type}>
                        <div className='map-building-mobile-utility-value'>
                            <span aria-hidden>{icon}</span>
                            <strong>{devicesCounts?.[type] || 0}</strong>
                        </div>
                        <span className='map-building-mobile-utility-label'>{localizedStrings[labels[type]]}</span>
                    </li>
                ))}
            </ul>
        );
    }

    return (
        <section className='flex flex-wrap justify-center items-center gap-x-6 gap-y-4 py-2 px-6'>
            {indicatorIcons.map(({type, icon}) => (
                <ObjectUtilityItem key={type} icon={icon} count={devicesCounts?.[type] || 0} />
            ))}
        </section>
    );
};

const ObjectUtilityItem = ({icon, count}) => (
    <div className='flex flex-col items-center group cursor-default'>
        <div className='w-11 h-11 bg-[#ECF5F9] rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-solitude shadow-sm'>
            {icon}
        </div>
        <div className='mt-1.5 font-bold text-zambezi text-12'>{count}</div>
    </div>
);

export default ObjectUtilitiesDrawerSection;
